export default __webpack_public_path__ + "static/media/avatar_38.409483f1.png";